import { observer } from "mobx-react-lite"

import { useLiquidityPageContext } from "@/domains/liquidity-page/context/liquidity-page-context"
import { ZapIdle } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/1.zap-idle"
import { ZapGettingEstimate } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/2.zap-getting-estimate"
import { ZapEstimated } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/3.zap-estimated"
import { ZapEstimateFailed } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/4.zap-estimate-failed"
import { ZapGettingApprovalStatus } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/5.zap-getting-approval-status"
import { ZapApprovalRequired } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/6.zap-approval-required"
import { ZapApproving } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/7.zap-approving"
import { ZapExecuting } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/10.zap-executing"
import { ZapCompleted } from "@/domains/minimal-pools-zap/components/zap/composables/zap-panels/11.zap-completed"
import { ZapStore } from "@/domains/minimal-pools-zap/zap-store"

import { ZapApprovalFailed } from "./9.zap-approval-failed"
import { ZapExecutionFailed } from "./12.zap-execution-failed"

export const ZapStateComponentMap = observer(({ store }: { store: ZapStore }) => {
  const { tokenRepository } = useLiquidityPageContext()
  const tokens = tokenRepository ? tokenRepository.getAll() : []
  switch (store.state) {
    // step one
    case "idle":
      return <ZapIdle store={store} tokens={tokens} />

    // step two
    case "gettingEstimate":
      return <ZapGettingEstimate store={store} />

    // step three
    case "estimated":
      return <ZapEstimated store={store} />

    // step four
    case "estimateFailed":
      return <ZapEstimateFailed store={store} />

    // step five
    case "gettingApprovalStatus":
      return <ZapGettingApprovalStatus store={store} />

    // step six
    case "approvalRequired":
      return <ZapApprovalRequired store={store} />

    // step seven
    case "approving":
      return <ZapApproving store={store} />

    // step eight
    case "approved":
      return <ZapEstimated store={store} />

    // step nine
    case "approvalFailed":
      return <ZapApprovalFailed store={store} />

    // step ten
    case "executing":
      return <ZapExecuting store={store} />

    // step eleven
    case "completed":
      return <ZapCompleted store={store} />

    // step twelve
    case "executionFailed":
      return <ZapExecutionFailed store={store} />

    default:
      return <div>Unknown state</div>
  }
})
